// GroupNavbar.jsx

import React, { useState } from "react";
import { Menu, Image, Grid, Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import "../styles/GroupManagement.css";

const GroupNavbar = ({
  setToggle,
  navTitle,
  showGroupsCount,
  NavbarCollapse,
  handleOpenGroupAdd,
  groupSearchData,
}) => {
  const navBarTitle = navTitle || "Groups";
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value.toLowerCase());
    groupSearchData(event.target.value.toLowerCase());
  };

  const handleBack = async () => {
    navigate(`/dataconsole`);
  };

  return (
    <Menu fixed="top" className="navbar" borderless>
      <Menu.Menu
        className={`${!NavbarCollapse ? "" : "navbar-collapse document-navbar"}`}
      >
        {/* Mobile View and desktop view*/}
        {!NavbarCollapse ? (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left-group">
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                <Image src="/images/group.svg" alt="Groups" />
                <label>{navBarTitle || "Default"}</label>
              </Menu.Item>
            </React.Fragment>
            <Menu.Item className="menu-item-groups">
              <div className="tag">{showGroupsCount || 0} Groups</div>
            </Menu.Item>
            <Menu.Item>
              <div className="menu-item-search">
                <input
                  type="text"
                  id="groupSearchMobile"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder=" "
                  data-cy="group-search-input"
                />
                <label htmlFor="groupSearchMobile">
                  <img src="/images/search.svg" alt="Logo" />
                  Search
                </label>
              </div>
              {NavbarCollapse}
            </Menu.Item>
          </Grid>
        ) : (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left-group-desktop">
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                <Image src="/images/group.svg" alt="Groups" />
                <label>
                  {navBarTitle.length < 25
                    ? navBarTitle
                    : navBarTitle.slice(0, 24) + "..." || "Default"}
                </label>
              </Menu.Item>
            </React.Fragment>
            {/* Desktop landing Page */}
            <Menu.Item className="menu-item-groups">
              <div className="tag">{showGroupsCount || 0} Groups</div>
            </Menu.Item>
            <Menu.Item>
              <div className="menu-item-search">
                <input
                  type="text"
                  id="groupSearchDesktop"
                  value={inputValue}
                  onChange={handleInputChange}
                  placeholder=""
                  data-cy="group-search-input"
                />
                <label htmlFor="groupSearchDesktop">
                  <img src="/images/search.svg" alt="Logo" />
                  Search
                </label>
              </div>
              {NavbarCollapse}
            </Menu.Item>
          </Grid>
        )}
      </Menu.Menu>

      {/* Right-aligned content */}
      <Menu.Menu position="right">
        <React.Fragment>
          <Menu.Item className="hide-add-dataset-button-desktop">
            <Button
              primary
              onClick={handleOpenGroupAdd}
              className="button-data-console"
              data-cy="add-group-btn-link"
            >
              <div className="button-data-console-parent">
                <Image
                  src="/images/white-base-icons.svg"
                  alt="Create new group"
                />
                Create Group
              </div>
            </Button>
          </Menu.Item>
        </React.Fragment>
      </Menu.Menu>
    </Menu>
  );
};

export default GroupNavbar;